<div class="container-fluid">
  <form #empForm="ngForm">
    <!-- Header -->
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h4>{{headerText}}</h4>
      </div>
      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <button type="button" class="btn btn-default btn-sm" *ngIf="empForm.form.dirty" (click)="cancelEmp()">
            <i class="fas fa-ban"></i>&nbsp;Cancel
          </button>
          <button *ngIf="(empForm.form.valid && empForm.form.dirty)" type="button" class="btn btn-default btn-sm"
            (click)="saveEmp(emp)">
            <i class="fas fa-save"></i>&nbsp;Save
          </button>
        </div>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

    <!--  Employee Info  -->

    <div class="row">
      <div class="col-xs-12">

        <!--  Employee Info  -->

        <aims-form>
          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="000000" #aimsControl="ngModel" name="Employee #" id="employeeNumber"
                    [(ngModel)]="emp.employeeNumber" (change)="validateUserInput($event)" required [readonly]="!newEmp"/>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-checkbox #aimsControl="ngModel" name="Exempt ?" [(ngModel)]="emp.exempt" tabindex="-1"
                  (change)="defaultUnion(emp.exempt)"></mat-checkbox>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="50" #aimsControl="ngModel" class="fullWidth" id="lastName" type="text"
                    name="Last Name" [(ngModel)]="emp.lastName" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="50" #aimsControl="ngModel" class="fullWidth" id="firstName" type="text"
                    name="First Name" [(ngModel)]="emp.firstName" (change)="validateUserInput($event)" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="50" #aimsControl="ngModel" class="fullWidth" id="middleName" type="text"
                    name="Middle Name" [(ngModel)]="emp.middleName" (focus)="validateUserInput($event)"
                    (change)="validateUserInput($event)" />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="1" #aimsControl="ngModel" id="mi" type="text" name="Initial" disabled
                    [(ngModel)]="emp.mi" />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="50" #aimsControl="ngModel" class="fullWidth" id="aka" type="text"
                    name="Alias" [(ngModel)]="emp.aka" (change)="validateUserInput($event)" />
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.employmentTypeId" class="fullWidth"
                    name="Employment Type" required>
                    <mat-option *ngFor="let val of employmentTypeValues | async" [value]="val.employmentTypeId">
                      {{ val.employmentType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.employmentStatusId" class="fullWidth"
                    name="Employment Status" required>
                    <mat-option *ngFor="let val of employmentStatusValues | async" [value]="val.employmentStatusId">
                      {{ val.employmentStatusCode }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.clearanceStatusId" class="fullWidth"
                    name="Clearance Status" required>
                    <mat-option *ngFor="let val of clearanceStatusValues | async" [value]="val.clearanceStatusId">
                      {{ val.clearanceStatus }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Clearance Status Date" matInput #aimsControl="ngModel" [matDatepicker]="picker1"
                    [(ngModel)]="emp.clearanceDate" [max]="today" required />
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp)" [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="CAC Exp Date" matInput #aimsControl="ngModel" [matDatepicker]="picker2"
                    [(ngModel)]="emp.cacExpireDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" class="fullWidth" type="text" name="Login Name"
                    [(ngModel)]="emp.loginName" [disabled]="tenantUsesPsc" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="!newEmp" [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" class="fullWidth" type="text" id="yearsOfServiceValue"
                    name="Years of Service" style="border: none; text-align: left; background-color :white"
                    [(ngModel)]="yearsOfServiceValue" disabled />
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="false">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.unionAffiliationId" class="fullWidth" name="Union"
                    (selectionChange)="filterDepartments()" required>
                    <mat-option *ngFor="let val of unionValues | async" [value]="val.unionAffiliationId">
                      {{ val.unionAffiliationCode }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.departmentId" class="fullWidth" name="Department"
                    (selectionChange)="filterWorkSection()" required>
                    <mat-option *ngFor="let val of filteredDepartments" [value]="val.departmentId">
                      {{ val.department }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.workSectionId" class="fullWidth"
                    name="Work Section" (selectionChange)="filterJobTitle()" required>
                    <mat-option *ngFor="let val of filteredWorkSections" [value]="val.workSectionId">
                      {{ val.workSection }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.titleId" class="fullWidth" name="Job Title"
                    (selectionChange)="filterJobAssignment()" required>
                    <mat-option *ngFor="let val of filteredJobTitles" [value]="val.jobTitleId">
                      {{ val.jobTitle}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup #aimsControl="ngModel"
                  name="Assignment"
                  [gridText]="'Select an Assignment'"
                  [values]="filteredJobAssignments"
                  [popupValues]="filteredJobAssignments"
                  [displayPropertyName]="'assignmentDescription'"
                  [idPropertyName]="'employeeJobAssignmentId'"
                  [(ngModel)]="emp.employeeJobAssignmentId"
                  [columnsInGrid]="employeeJobAssignmentLookupColumns"
                  class="fullWidth"
                  id="employeeJobAssignmentLookup"
                  required>
                </aims-lookup>
              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-form>
            <aims-fc [showDescendants]="false">
              <aims-form [editable]="true" [cols]="1" [spaceRows]="false">

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name="Office Phone"
                      [(ngModel)]="emp.officePhone" />
                  </mat-form-field>
                </aims-fc>

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <input matInput mask="0000" #aimsControl="ngModel" name="Extension" [(ngModel)]="emp.extension" />
                  </mat-form-field>
                </aims-fc>

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name="Office Fax"
                      [(ngModel)]="emp.officeFax" />
                  </mat-form-field>
                </aims-fc>

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name="Cell"
                      [(ngModel)]="emp.arctecCellPhone" />
                  </mat-form-field>
                </aims-fc>
              </aims-form>
            </aims-fc>
          </aims-form>
        </aims-form>

        <ng-container *ngIf="!newEmp">
          <br />
          <aims-form>
            <aims-fc [showDescendants]="false">
              <aims-form [editable]="true" [cols]="1" [spaceRows]="false">

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-checkbox #aimsControl="ngModel" name="Shareholder ?" tabindex="-1"
                    (change)="shareholderUnchecked()" [(ngModel)]="emp.shareholder"> </mat-checkbox>
                </aims-fc>

                <aims-fc *ngIf="(emp.shareholder)" [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <mat-label></mat-label>
                    <mat-chip-list #chipList1 aria-label="Shareholder selection">
                      <mat-chip *ngFor="let val of emp.hrEmployeeXShareholderType" [selectable]="true"
                        [removable]="true" (removed)="removeEmpXShare(val)">
                        {{val.shareholderType.shareholderType}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input placeholder="" [formControl]="shareholderTypeFormControl" #shareholderTypeInput
                        [matAutocomplete]="auto1" [matChipInputFor]="chipList1"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addEmpXShare($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selectedEmpXShare($event)">
                      <mat-option *ngFor="let val of allShareholderTypesFiltered | async"
                        [value]="val.shareholderTypeId">
                        {{val.shareholderType}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </aims-fc>

              </aims-form>
            </aims-fc>

            <aims-fc [showDescendants]="false">
              <aims-form [editable]="true" [cols]="1" [spaceRows]="false">

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-checkbox #aimsControl="ngModel" name="Specialties ?" [(ngModel)]="emp.otherSpecialties"
                    tabindex="-1" (change)="otherSpecialtyUnchecked()"> </mat-checkbox>
                </aims-fc>

                <aims-fc *ngIf="(emp.otherSpecialties)" [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <mat-label></mat-label>
                    <mat-chip-list #chipList2 aria-label="Specialty selection">
                      <mat-chip *ngFor="let val of emp.hrEmployeeXOtherSpecialtyType" [selectable]="true"
                        [removable]="true" (removed)="removeEmpXOtherSpecialty(val)">
                        {{val.otherSpecialtyType.otherSpecialtyType}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input placeholder="" [formControl]="otherSpecialtyTypeFormControl" #otherSpecialtyTypeInput
                        [matAutocomplete]="auto2" [matChipInputFor]="chipList2"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="addEmpXOtherSpecialty($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selectedEmpXOtherSpecialty($event)">
                      <mat-option *ngFor="let val of allOhterSpecialtyTypesFiltered | async"
                        [value]="val.otherSpecialtyTypeId">
                        {{val.otherSpecialtyType}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </aims-fc>

              </aims-form>
            </aims-fc>

            <aims-fc [showDescendants]="false">
              <aims-form [editable]="true" [cols]="1" [spaceRows]="false">
                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-checkbox #aimsControl="ngModel" name="Veteran ?" tabindex="-1" [(ngModel)]="emp.veteran">
                  </mat-checkbox>
                </aims-fc>
              </aims-form>
            </aims-fc>

            <aims-fc [showDescendants]="false">
              <aims-form [editable]="true" [cols]="1" [spaceRows]="false">

                <aims-fc [labelColSize]="5" [controlColSize]="7">
                  <mat-checkbox #aimsControl="ngModel" tabindex="-1" name="Protected Vet ?"
                    [(ngModel)]="emp.protectedVeteran"> </mat-checkbox>
                </aims-fc>

                <aims-fc *ngIf="emp.protectedVeteran" [labelColSize]="5" [controlColSize]="7">
                  <mat-form-field>
                    <input name="Separation/Discharged" matInput #aimsControl="ngModel" [matDatepicker]="picker3"
                      [(ngModel)]="emp.veteranDischargeDate" [max]="today" />
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                  </mat-form-field>
                </aims-fc>
              </aims-form>
            </aims-fc>

          </aims-form>
          <br />
        </ng-container>

        <!--  Current Info  -->

        <aims-form [header]="'Current Status Information'" [hider]="!newEmp">
          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.employeeStatusId" class="fullWidth"
                    name="Employee Status" required>
                    <mat-option *ngFor="let val of employeeStatusValues | async" [value]="val.employeeStatusId">
                      {{ val.employeeStatus}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp && emp.termDateLayoffDate != null)" [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Term or Layoff Date" matInput #aimsControl="ngModel" [matDatepicker]="picker4"
                    [(ngModel)]="emp.termDateLayoffDate" [max]="today" />
                  <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp && emp.termDateLayoffDate != null)" [labelColSize]="5" [controlColSize]="7">
                <input #aimsControl="ngModel" type="checkbox" name="Eligible for Rehire?"
                  [(ngModel)]="emp.eligibleForRehire" />
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.permanentSiteId" class="fullWidth"
                    name="Permanent Site" required>
                    <mat-option *ngFor="let val of siteValues" [value]="val.siteId">
                      {{ val.siteCode}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Orig Date of Hire" matInput #aimsControl="ngModel" [matDatepicker]="picker7"
                    [(ngModel)]="emp.originalDateofHire" required [max]="today" />
                  <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                  <mat-datepicker #picker7></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp && emp.lastEoaDate != null)" [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Last EOA Date" matInput #aimsControl="ngModel" [matDatepicker]="picker5"
                    [(ngModel)]="emp.lastEoaDate" [max]="today" />
                  <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                  <mat-datepicker #picker5></mat-datepicker>
                </mat-form-field>
              </aims-fc>

            </aims-form>
          </aims-fc>

          <aims-fc *ngIf="tenantUsesPsc" [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Dispatch Date" matInput #aimsControl="ngModel" [matDatepicker]="picker6"
                    [(ngModel)]="emp.assignmentStartDate" [max]="today"
                    [required]="emp.unionAffiliationId != empConfig.defaultUnionId" />
                  <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                  <mat-datepicker #picker6></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="!newEmp && emp.pmcfrontecArctecHireDate != null" [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="PMC Frontec" matInput #aimsControl="ngModel" [matDatepicker]="picker8"
                    [(ngModel)]="emp.pmcfrontecArctecHireDate" [max]="today" disabled />
                  <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                  <mat-datepicker #picker8></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="!newEmp && emp.bridgedDateofHire != null" [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Bridged Date of Hire" matInput #aimsControl="ngModel" [matDatepicker]="picker9"
                    [(ngModel)]="emp.bridgedDateofHire" [max]="today" disabled />
                  <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
                  <mat-datepicker #picker9></mat-datepicker>
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc *ngIf="tenantUsesPsc" [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="newEmp">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-checkbox #aimsControl="ngModel" name="Probation Required ?" [(ngModel)]="isProbationRequired"
                  tabindex="-1"> </mat-checkbox>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field *ngIf="((newEmp && isProbationRequired) || emp.probationStart != null)">
                  <input name="Probation Start" matInput #aimsControl="ngModel" [matDatepicker]="picker10"
                    [(ngModel)]="emp.probationStart" [max]="today" [required]="isProbationRequired" />
                  <mat-datepicker-toggle matSuffix [for]="picker10"></mat-datepicker-toggle>
                  <mat-datepicker #picker10></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp && emp.probationaryCompletionDate != null)" [labelColSize]="5"
                [controlColSize]="7">
                <mat-form-field>
                  <input name="Probation Comp" matInput #aimsControl="ngModel" [matDatepicker]="picker11"
                    [(ngModel)]="emp.probationaryCompletionDate" [max]="today" disabled />
                  <mat-datepicker-toggle matSuffix [for]="picker11"></mat-datepicker-toggle>
                  <mat-datepicker #picker11></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp && (emp.recallExpireDate != null || emp.returnTravelorRecallRights != null))"
                [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Recall Expire Date" matInput #aimsControl="ngModel" [matDatepicker]="picker12"
                    [(ngModel)]="emp.recallExpireDate" disabled />
                  <mat-datepicker-toggle matSuffix [for]="picker12"></mat-datepicker-toggle>
                  <mat-datepicker #picker12></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="(!newEmp && (emp.recallExpireDate != null || emp.returnTravelorRecallRights != null))"
                [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" maxlength="100" class="fullWidth" type="text"
                    name="Recall Rights" [(ngModel)]="emp.returnTravelorRecallRights" [min]="today" required />
                </mat-form-field>
              </aims-fc>
            </aims-form>

          </aims-fc>
          <aims-fc [isSpacer]="true"></aims-fc>
        </aims-form>
        <ng-container *ngIf="!newEmp">
          <br />
        </ng-container>

        <!--  Address / Contact Information  -->
        <aims-form [editable]="newEmp" [cols]="4" [header]="'Address / Contact Information'" [hider]="!newEmp"
          *ngIf="tenantUsesPsc">

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [header]="'Home'" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="100" #aimsControl="ngModel" class="fullWidth" type="text"
                    name="Street Address" [(ngModel)]="emp.homeAddress" (change)="handleHomeStreetChanged()" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="50" #aimsControl="ngModel" class="fullWidth" type="text" name="City"
                    [(ngModel)]="emp.homeCity" (change)="handleHomeCityChanged()" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup
                  #aimsControl="ngModel"
                  name="State"
                  [gridText]="'Select a State or Territory'"
                  [values]="stateOrTerritoryValues | async"
                  [popupValues]="stateOrTerritoryValues | async"
                  [displayPropertyName]="'postalCode'"
                  [idPropertyName]="'stateOrTerritoryId'"
                  [(ngModel)]="emp.homeStateId"
                  [columnsInGrid]="stateLookupColumns"
                  class="fullWidth" id="hStateLookup"
                  (valueChange)="handleHomeStateChanged($event)" required>
                </aims-lookup>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="00009-9999" [dropSpecialCharacters]="false" #aimsControl="ngModel" class="fullWidth" type="text" name="Zip Code"
                    [(ngModel)]="emp.homeZip" (change)="handleHomeZipChanged()" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc *ngIf="newEmp" [labelColSize]="5" [controlColSize]="7">
                <mat-checkbox #aimsControl="ngModel" name="Mailing address the same?" [(ngModel)]="isSameAddress"
                  (change)="handleSameAddressChecked()"></mat-checkbox>
              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [header]="'Mailing'" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="100" #aimsControl="ngModel" class="fullWidth" type="text"
                    name=" Street Address" [(ngModel)]="emp.mailingAddress" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput maxlength="50" #aimsControl="ngModel" class="fullWidth" type="text" name=" City"
                    [(ngModel)]="emp.mailingCity" (change)="handleHomeCityChanged()" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup
                  #aimsControl="ngModel"
                  name=" State"
                  [gridText]="'Select a State or Territory'"
                  [values]="stateOrTerritoryValues | async"
                  [popupValues]="stateOrTerritoryValues | async"
                  [displayPropertyName]="'postalCode'"
                  [idPropertyName]="'stateOrTerritoryId'"
                  [(ngModel)]="emp.mailingStateId"
                  [columnsInGrid]="stateLookupColumns"
                  class="fullWidth"
                  id="mStateLookup"
                  required>
                </aims-lookup>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="00009-9999" [dropSpecialCharacters]="false" #aimsControl="ngModel" class="fullWidth" type="text"
                    name=" Zip Code" [(ngModel)]="emp.mailingZip" required />
                </mat-form-field>

              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [header]="'Employee Contact'" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name="Primary #"
                    [(ngModel)]="emp.homePhone" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name="Alternate #"
                    [(ngModel)]="emp.messagePhone" />
                </mat-form-field>
              </aims-fc>

            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [header]="'Emergency Contact'" [spaceRows]="false">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" class="fullWidth" id="emergLastName" type="text"
                    name=" Last Name" maxlength="50" [(ngModel)]="emp.emergencyContactLastName" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" class="fullWidth" id="emergFirstName" type="text"
                    name=" First Name" maxlength="50" [(ngModel)]="emp.emergencyContactFirstName" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name=" Primary #"
                    [(ngModel)]="emp.emergencyContactPhoneNo1" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput mask="000-000-0000" [dropSpecialCharacters]="false" #aimsControl="ngModel" name=" Alternate #"
                    [(ngModel)]="emp.emergencyContactPhoneNo2" />
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </aims-fc>
        </aims-form>
        <ng-container *ngIf="!newEmp">
          <br />
        </ng-container>

        <!--  Personal Info  -->

        <aims-form [editable]="newEmp" [cols]="4" [header]="'Personal Information'" [hider]="!newEmp" *ngIf="tenantRequiresPersonalInfo">
          <aims-fc [showDescendants]="false">
            <aims-form [editable]="true" [cols]="1" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Birthdate" matInput #aimsControl="ngModel" [matDatepicker]="picker13"
                    [(ngModel)]="emp.birthdate" [max]="today" required />
                  <mat-datepicker-toggle matSuffix [for]="picker13"></mat-datepicker-toggle>
                  <mat-datepicker #picker13></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" name="SSN" id="ssn" [mask]="'000-00-0000'" [dropSpecialCharacters]="false"
                    [(ngModel)]="emp.ssn" (change)="validateUserInput($event)" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.genderTypeId" class="fullWidth" name="Gender Type"
                    required>
                    <mat-option *ngFor="let val of genderTypeValues | async" [value]="val.genderTypeId">
                      {{ val.genderType}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.eeoId" class="fullWidth" name="EEO" required *ngIf="!newEmp">
                    <mat-option *ngFor="let val of eeoTypeValues | async" [value]="val.eeoId">
                      {{ val.eeoType}}
                    </mat-option>
                  </mat-select>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.eeoId" class="fullWidth" name="EEO" required *ngIf="newEmp">
                    <mat-option *ngFor="let val of activeEeoTypeValues | async" [value]="val.eeoId">
                      {{ val.eeoType}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <mat-select #aimsControl="ngModel" [(ngModel)]="emp.maritalStatusId" class="fullWidth"
                    name="Marital Status" required>
                    <mat-option *ngFor="let val of maritalStatusValues | async" [value]="val.maritalStatusId">
                      {{ val.maritalStatus}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="true" [cols]="1">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" mask="009" id="travelWeight" type="text" name="Travel Weight"
                    [(ngModel)]="emp.bodyWeight" />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-checkbox #aimsControl="ngModel" name="Military Transport Auth"
                  title="Military Transport Authorized?" [(ngModel)]="emp.militaryTransportAuthorized" tabindex="-1">
                </mat-checkbox>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <textarea matInput #aimsControl="ngModel" class="fullWidth" id="additionalInfo" type="text"
                    name="Additional Info" maxlength="255" [(ngModel)]="emp.additionalInfo">
                </textarea>
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </aims-fc>

          <aims-fc [showDescendants]="false">
            <aims-form [editable]="true" [cols]="1">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" name="Passport" id="passport" [mask]="'A00000000'" [dropSpecialCharacters]="false"
                    [(ngModel)]="emp.passportNumber" />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Passport Exp" matInput #aimsControl="ngModel" [matDatepicker]="picker14"
                    [(ngModel)]="emp.passportExp" />
                  <mat-datepicker-toggle matSuffix [for]="picker14"></mat-datepicker-toggle>
                  <mat-datepicker #picker14></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" name="DOD #" id="dodnum" [mask]="'0000000000'" [dropSpecialCharacters]="false"
                    [(ngModel)]="emp.dodNumber" />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="DOD # Exp" matInput #aimsControl="ngModel" [matDatepicker]="picker15"
                    [(ngModel)]="emp.dodNumberExp" />
                  <mat-datepicker-toggle matSuffix [for]="picker15"></mat-datepicker-toggle>
                  <mat-datepicker #picker15></mat-datepicker>
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </aims-fc>
        </aims-form>

        <aims-form [editable]="newEmp" [cols]="4" [header]="'Driver\'s License'" [hider]="!newEmp" *ngIf="tenantRequiresPersonalInfo">
          <aims-fc [showDescendants]="false">
            <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="false">

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input matInput #aimsControl="ngModel" maxlength="25" class="fullWidth" type="text" name="License #"
                    [(ngModel)]="emp.driversLicense" required />
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup
                  #aimsControl="ngModel"
                  name="  State"
                  [gridText]="'Select a State or Territory'"
                  [values]="stateOrTerritoryValues | async"
                  [popupValues]="stateOrTerritoryValues | async"
                  [displayPropertyName]="'postalCode'"
                  [idPropertyName]="'stateOrTerritoryId'"
                  [(ngModel)]="emp.driversLicenseStateId"
                  [columnsInGrid]="stateLookupColumns"
                  class="fullWidth"
                  id="dlStateLookup"
                  required>
                </aims-lookup>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                  <input name="Exp Date" matInput #aimsControl="ngModel" [matDatepicker]="picker16"
                    [(ngModel)]="emp.driversLicenseExpDate" required />
                  <mat-datepicker-toggle matSuffix [for]="picker16"></mat-datepicker-toggle>
                  <mat-datepicker #picker16></mat-datepicker>
                </mat-form-field>
              </aims-fc>

            </aims-form>
          </aims-fc>
        </aims-form>


        <ng-container *ngIf="!newEmp">
          <br />
        </ng-container>

        <!--  OCC Info  -->
        <aims-form *ngIf="displayOccInfo && emp.unionAffiliationId != empConfig.defaultUnionId" [editable]="false"
          [cols]="1" [header]="'Occupation Certification Classification (OCC) Information'" [hider]="!newEmp">
          <div id="gridOcc">
            <div class="row">
              <div class="col-xs-12">
                <aims-common-table id="occ-table" [dataSource]="emp.hrOcc" [header]="occHeader" [pageSize]="5"
                  [permissions]="occTablePermissions">

                  <aims-common-table-dynamic-row id="jobTitleId">
                    <ng-template viewMode let-element>{{ element.jobTitleId|
                      getText:'jobTitleId':'jobTitle':jobTitleValues | async}}
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="occStatusId">
                    <ng-template viewMode let-element>{{ element.occStatusId|
                      getText:'occStatusId':'occStatus':occStatusValues | async}}
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="employmentTypeId">
                    <ng-template viewMode let-element>{{ element.employmentTypeId|
                      getText:'employmentTypeId':'employmentTypeCode':employmentTypeValues| async}}
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="workSectionId">
                    <ng-template viewMode let-element>{{ element.workSectionId|
                      getText:'workSectionId':'workSection':workSectionValues| async}}
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>

              </div>
            </div>

          </div>
        </aims-form>
        <ng-container *ngIf="!newEmp && !emp.exempt">
          <br />
        </ng-container>

        <!--  PSC Info  -->
        <aims-form *ngIf="displayPscInfo" [editable]="false" [cols]="1"
          [header]="'Personnel Status Change (PSC) Information'" [hider]="!newEmp">
          <div id="gridPsc">
            <div class="row">
              <div class="col-xs-12">
                <aims-common-table id="pscs-table" [dataSource]="emp.hrPscEmployee" [header]="pscsHeader" [pageSize]="5"
                  [permissions]="pscTablePermissions">

                  <aims-common-table-dynamic-row id="button">
                    <ng-template viewMode let-element>
                      <button *ngIf="permissions.canUpdate(permissions.ComponentID.PSC)" type="button" mat-mini-fab
                        color="basic" aria-label="Route to PSC"
                        [routerLink]="'/hr/psc/' + element.pscId +'/' +routedFrom">
                        <mat-icon>launch</mat-icon>
                      </button>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="employeeStatusToId">
                    <ng-template viewMode let-element>{{ element.employeeStatusToId|
                      getText:'employeeStatusId':'employeeStatus':employeeStatusValues | async}}
                    </ng-template>
                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" class="top20 fullWidth">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter"
                          [ngModelOptions]="{standalone: true}">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let val of employeeStatusValues | async" [value]="val.employeeStatusId">
                            {{val.employeeStatus}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="pscTypeId">
                    <ng-template viewMode let-element>{{ element.pscTypeId|
                      getText:'pscTypeId':'pscType':pscTypeValues | async}}
                    </ng-template>
                    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                      <mat-form-field appearance="fill" class="top20 fullWidth">
                        <mat-label>Filter</mat-label>
                        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter"
                          [ngModelOptions]="{standalone: true}">
                          <mat-option label=""></mat-option>
                          <mat-option *ngFor="let val of pscTypeValues | async" [value]="val.pscTypeId">
                            {{val.pscType}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>

              </div>
            </div>
          </div>
        </aims-form>
      </div>
    </div>
  </form>


  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
